import styled, { css } from 'styled-components'

import { BlueGradientButton, StyledButton } from 'components'
import { Card } from 'components/common/atoms/card'
import { SHADOW_LV2, COLOR } from 'styles/constants'
import { elementStyle } from 'styles/element-style'

export const StyledHeaderSection = styled.div`
  ${elementStyle}
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledBodySection = styled.div`
  ${elementStyle}
  margin-top: 20px;
  display: grid;
  grid-template-columns: 55% 45%;

  & > * {
    font-size: 14px;
    line-height: 24px;
  }

  & > *:nth-child(odd) {
    justify-self: start;
    font-weight: 600;
  }

  & > *:nth-child(even) {
    justify-self: end;
    font-weight: 400;
  }
`
export const StyledApplyButton = styled(BlueGradientButton)`
  display: block;
  border-radius: 24px;
  width: 100%;
  height: 48px;
`

export const StyledContactButton = styled(StyledButton)`
  border-radius: 24px;
  border: 1px solid ${COLOR.GREY_LV3};
  width: 100%;
  background-color: ${COLOR.WHITE};
  ${(props) =>
    props.disabled &&
    `
    border: none;
    background-color: ${COLOR.GRAY_SCALE_15};
  `}
  transition: all 0.3s ease-in-out;
  &:hover {
    ${(props) => !props.disabled && `background-color: ${COLOR.GRAY_SCALE_15};`}
  }
  height: 48px;
`

export const StyledButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  space-between: 20px;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;

  ${StyledContactButton} {
    margin-top: 10px;
  }

  ${StyledApplyButton} {
    margin-top: 0;
  }
`

export const StyledCard = styled(Card)<IElement & { isSticky: boolean }>`
  ${elementStyle}
  box-shadow: ${SHADOW_LV2};
  padding: 20px;
  width: 100%;
  position: relative;

  ${({ isSticky = false }) =>
    isSticky
      ? css`
          ${StyledBodySection} {
            display: none;
          }

          ${StyledContactButton} {
            width: 48%;
          }

          ${StyledApplyButton} {
            width: 48%;
          }

          ${StyledButtonGroup} {
            flex-direction: row-reverse;
            justify-content: space-between;
            margin-top: 10px;
            align-items: baseline;
          }
        `
      : css`
          border-radius: 8px;
        `}
`
